module.exports = __webpack_public_path__ + "static/async_with_callback_and_autosale-53e1f6fffc07d54e6da234ab529aae04.png";